import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { fetchIv_list, fetchJb_list, fetchSettings } from '../../../store';
import { findSeqIndex } from '../../../utils/seqDataUtils';

function JbMeasurementTotalList() {
  const dispatch = useDispatch();
  const [blink, setBlink] = useState(false);
  const [MaxEffCurrentCheck, setMaxEffCurrentCheck] = useState('50.0');
  const [MinEffCurrentCheck, setMinEffCurrentCheck] = useState('10.0');

  const Jb_list = useSelector((state) => state.Jb_list || {});
  const JbMrtData = useSelector((state) => state.JbMrtData || {});
  const settingList = useSelector((state) => state.settingList || {});

  // 설정값 로드
  useEffect(() => {
    if (settingList.Etc_Setting) {
      setMinEffCurrentCheck(settingList.Etc_Setting.MinEffCurrentCheck);
      setMaxEffCurrentCheck(settingList.Etc_Setting.MaxEffCurrentCheck);
    }
  }, [settingList.Etc_Setting]);

  // 설정 데이터 가져오기
  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  // 깜빡임 효과
  useEffect(() => {
    const timer = setInterval(() => {
      setBlink(prev => !prev);
    }, 500);
    return () => clearInterval(timer);
  }, []);

  const getBackgroundColor = (current) => {
    if (current === undefined || current === null) return '#ffffff';

    const step = Math.floor(current * 10);

    if (current <= 10) {
      const ratio = step / 100;
      const r = Math.round(237 - (237 * ratio));
      const g = Math.round(82 - (82 * ratio));
      const b = Math.round(84 + (171 * ratio));
      return `rgb(${r}, ${g}, ${b})`;
    } else {
      const ratio = (step - 100) / 100;
      const r = 0;
      const g = Math.round(255 * ratio);
      const b = 255;
      return `rgb(${r}, ${g}, ${b})`;
    }
  };
  const getActiveChannels = (index) => {
    const channelUseArray = Jb_list.jb_pv_ch_use && Jb_list.jb_pv_ch_use[index]
      ? Jb_list.jb_pv_ch_use[index].split(",")
      : Array(24).fill("0");

    return channelUseArray.map((use, i) => ({
      use: use === "1",
      index: i
    }));
  };

  const isAllZero = (jbData) => {
    const allCurrentsZero = jbData.pvChCurrent.every(current => current === 0);
    const totalValuesZero =
      jbData.pvTotalCurrent === 0 &&
      jbData.PvTotalVolt === 0 &&
      jbData.temperature === 0;

    return allCurrentsZero && totalValuesZero;
  };

  const isEfficiencyAlarm = (currentArray) => {
    const maxCurrent = Math.max(...currentArray.map(curr => curr / 10));
    if (maxCurrent >= parseFloat(MaxEffCurrentCheck)) {
      return currentArray.some(curr => (curr / 10) <= parseFloat(MinEffCurrentCheck) && curr !== 0);
    }
    return false;
  };

  const getChannelStyle = (current, isActive, jbData) => {
    if (!isActive) return { backgroundColor: '#ffffff', color: '#000000' };

    const normalBgColor = getBackgroundColor(current / 10);
    const isEfficiencyWarning =
      current / 10 <= parseFloat(MinEffCurrentCheck) &&
      Math.max(...jbData.pvChCurrent.map(c => c / 10)) >= parseFloat(MaxEffCurrentCheck) &&
      current !== 0;

    return {
      backgroundColor: isEfficiencyWarning && blink ? '#FF6B6B' : normalBgColor,
      color: '#ffffff',
      transition: 'background-color 0.3s'
    };
  };

  const isAbnormal = (jbData) => {
    return isAllZero(jbData) || isEfficiencyAlarm(jbData.pvChCurrent);
  };
  // 계측장비-접속함-전체보기
  return (
    <div className="jb-total-list-container" >
      {/* 상단 경보 설명 영역 */}
      <div style={{ marginBottom: '10px', textAlign: 'left' }}>
        <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
          {/* 경보 이미지 */}
          <img src={require('../../../image/icons/Currentbunpo.png')} alt="Currentbunpo" />
          {/* 경보 설명 문구 */}
          <p style={{ color: '#96909F', marginLeft: '50px', textAlign: 'center', marginTop: 'auto', marginBottom: 'auto', fontWeight: 'bold' }}>
            각 접속함내 전류 최대값이 <span style={{ color: '#FF6B6B' }}>{MaxEffCurrentCheck}A</span> 이상이고 해당채널이
            &nbsp;<span style={{ color: '#FF6B6B' }}>{MinEffCurrentCheck}A</span> 이하이면 효율경보(알람) 발생
          </p>
        </div>
      </div>

      {/* 데이터 테이블 */}
      <table className="jb-table" style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
        <thead style={{ display: 'table', tableLayout: 'fixed' }}>
          <tr className="header-row">
            {/* 각 열의 제목 (번호, 장비명, 상태, 채널, 전류, 전압, 내부 온도) */}
            <th className="fixed-col" rowSpan={2} style={{ borderTopLeftRadius: '10px', width: '50px' }}>번호</th>
            <th className="fixed-col" rowSpan={2} style={{ width: '110px' }}>장비명</th>
            <th className="fixed-col" rowSpan={2} style={{ width: '80px' }}>상태</th>
            <th colSpan="24" className="ch-header" style={{}}>CH(A)</th>
            <th className="fixed-col" rowSpan={2} style={{ width: '60px' }}>전류<br />(A)</th>
            <th className="fixed-col" rowSpan={2} style={{ width: '60px' }}>전압<br />(V)</th>
            <th className="fixed-col" rowSpan={2} style={{ width: '60px', borderTopRightRadius: '10px' }}>내부온도<br />(℃)</th>
          </tr>
           {/* 채널 번호 헤더 (1~24) */}
          <tr className="subheader-row">
            {Array.from({ length: 24 }, (_, i) => (
              <th key={i + 1} className="ch-number" style={{}}>{i + 1}</th>
            ))}
          </tr>
        </thead>
        {/* 테이블 본문 - 데이터를 동적으로 표시 */}
        <tbody style={{ display: 'block', maxHeight: '615px', overflowY: 'auto', width: '100%' }}>
          {(Jb_list.seq || []).map((seq, i) => ({ seq, i }))
            .filter(({ seq, i }) => {
              const protocolArr = Jb_list.jb_protocol || [];
              const proto = protocolArr[i] || '';
              // 비엔엠은 부모만 표시, 자식(Bnm_lc/Bnm_co)은 숨김
              if (proto === 'Bnm_lc' || proto === 'Bnm_co') return false;
              return true;
            })
            .map(({ seq, i }, rowIdx) => {
            // 활성 채널 가져오기 (원본 인덱스 i 사용)
            const activeChannels = getActiveChannels(i);
            // 해당 장비의 데이터 설정 (실시간 seq 인덱스 사용)
            const dataIndex = findSeqIndex(JbMrtData, seq);
            const jbData = {
              pvChVolt: JbMrtData.pvChVolt?.[dataIndex] || Array(24).fill(0),
              pvChCurrent: JbMrtData.pvChCurrent?.[dataIndex] || Array(24).fill(0),
              temperature: JbMrtData.temperature?.[dataIndex] || 0,
              PvTotalVolt: JbMrtData.PvTotalVolt?.[dataIndex] || 0,
              pvTotalCurrent: JbMrtData.pvTotalCurrent?.[dataIndex] || 0,
            };

            return (
              // 데이터 행 생성
              <tr key={seq} style={{ marginBottom: '-1px', display: 'table', width: '100%', tableLayout: 'fixed' }}>
                {/* 번호 */}
                <td className="fixed-col" style={{ width: '50px'  }}>{rowIdx + 1}</td>
                {/* 장비명*/}
                {(() => {
                  const nameArr = Jb_list.jb_name || [];
                  return (
                    <td className="fixed-col" style={{ width: '110px' }}>{nameArr[i]}</td>
                  );
                })()}
                {/* 장비 상태 표시 (정상/이상) */}
                <td className="fixed-col" style={{ width: '80px' }}>
                  <div className="status-indicator" style={{
                    backgroundColor: isAbnormal(jbData) ? '#FF6B6B' : '#4CAF50'
                  }}>
                    {isAbnormal(jbData) ? '이상' : '정상'}
                  </div>
                </td>
                 {/* 24개 채널의 전류값 표시 */}
                {Array.from({ length: 24 }, (_, chIdx) => (
                  <td
                    key={chIdx}
                    className="ch-value"
                    style={{
                      ...getChannelStyle(jbData.pvChCurrent[chIdx], activeChannels[chIdx].use, jbData)
                    }}
                  >
                    {/* 해당 채널이 활성화된 경우 값 표시, 아니면 '-' */}
                    {activeChannels[chIdx].use
                      ? (jbData.pvChCurrent[chIdx] / 10).toFixed(1)
                      : '-'}
                  </td>
                ))}
                {/* 전체 전류값 */}
                <td className="fixed-col" style={{ width: '60px' }}>{(jbData.pvTotalCurrent / 10).toFixed(1)}</td>
                {/* 전체 전압값 */}
                <td className="fixed-col" style={{ width: '60px' }}>{(jbData.PvTotalVolt / 10).toFixed(1)}</td>
                {/* 내부 온도값 */}
                <td className="fixed-col" style={{ width: '60px' }}>{(jbData.temperature / 10).toFixed(1)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default JbMeasurementTotalList;
